import { useEffect, useState } from "react";
import "./index.css";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase/config";
import AwardsRow from "../../General/AwardsRow";

function AccoladesAssociations() {
  const [accolades, setAccolades] = useState([]);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "accolades"), (snap) => {
      setAccolades(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  return (
    <div
      class="mediaSectionWrap mediaSectionWrapA animated-section section"
      id="sec17"
    >
      <div class="scrollSection">
        <div class="container">
          <div class="mediaRow">
            <h2 class="titleText">
              Our <span class="skyText">Accolades</span> & {""}
              <span class="skyText">Associations</span>
            </h2>
            <AwardsRow items={accolades} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccoladesAssociations;
